import React from 'react';
import { Table, Button } from 'reactstrap';

//Componentes auxiliares:

//Scripts auxiliares:
let dateFormatter = require('../../tools/formatters/dateFormatter');

//Variables auxiliares:
let tableColumnsList = [
    {
        title: "Usuario",
        key: "userEmail",
        style: { textAlign: "center" }
    },
    {
        title: "Fecha",
        key: "created",
        style: { textAlign: "center", minWidth: 120 }
    },
    {
        title: "Descripción",
        key: "description",
        style: { textAlign: "left" }
    }
];

const paginationSize = 5;

//Estilos base:
let paragraphBaseStyles = { textTransform: "none", marginBottom: 0, paddingTop: 5 };

class AuditRecordsTable extends React.Component {

    constructor() {
        super();

        this.state = {
            targetData: [],
            sortingActiveKey: "",
            sortingActiveDirection: ""
        }
    }

    render() {
        return (
            <div>
                <Table style={{ marginBottom: 0 }}>
                    {this.getTableHeaders()}
                    <tbody>
                        {this.getTableRows()}
                    </tbody>
                </Table>

                <hr style={{ marginTop: 0 }} />

                <div style={{ display: "flex", textAlign: "center" }}
                    data-tut="reactour__auditView.auditRecordsTablePagination">

                    <div style={{ flex: "50%", display: "flex", justifyContent: "flex-start" }}>
                        <Button style={{ marginLeft: 5, marginRight: 5 }} outline color="success"
                            disabled={(this.props.activeQuantity >= this.state.targetData.length)}
                            onClick={() => {
                                this.props.updateActiveQuantity(this.state.targetData.length);
                            }}>Ver todo</Button>
                    </div>

                    <div style={{ flex: "50%", display: "flex", justifyContent: "flex-end" }}>
                        <Button style={{ marginLeft: 5, marginRight: 5 }}
                            disabled={(this.props.activeQuantity <= paginationSize)}
                            onClick={() => {
                                if (!(this.props.activeQuantity <= paginationSize)) {
                                    this.props.updateActiveQuantity(this.props.activeQuantity - paginationSize);
                                }
                            }}>Ver menos</Button>

                        <Button color="info" style={{ marginLeft: 5, marginRight: 5 }}
                            disabled={(this.props.activeQuantity > this.state.targetData.length)}
                            onClick={() => {
                                if (!(this.props.activeQuantity > this.state.targetData.length)) {
                                    this.props.updateActiveQuantity(this.props.activeQuantity + paginationSize);
                                }
                            }}>Ver más</Button>
                    </div>
                </div>
            </div>
        );
    }

    componentDidMount() {
        this.setState({ targetData: this.props.targetData || [] });
    }

    componentDidUpdate() {
        if (JSON.stringify(this.state.targetData) !== JSON.stringify(this.props.targetData)) {
            this.setState({ targetData: this.props.targetData });
        }
    }

    //Métodos para el renderizado de los elementos de la tabla:
    getEmailBolded = (email) => {
        let spplitedEmail = email.split("@");
        return ("<b>" + spplitedEmail[0] + "</b>@" + spplitedEmail[1]);
    }

    getFinishDateLabel = (targetProcess) => {
        if (targetProcess.status !== "IN_PROCESS") {
            return (
                <React.Fragment>
                    <p style={{ marginBottom: 0, paddingLeft: 0 }}>
                        {dateFormatter.getShortDate(new Date(targetProcess.end_date || targetProcess.modified))}
                    </p>
                    <p className="category" style={{ ...paragraphBaseStyles, paddingLeft: 0 }}>
                        {dateFormatter.getShortHour(new Date(targetProcess.end_date || targetProcess.modified))}
                    </p>
                </React.Fragment>
            );
        }
        else {
            return (
                <React.Fragment>
                    <p style={{ marginBottom: 0, paddingLeft: 0 }}>
                        -
                    </p>
                    <p className="category" style={{ ...paragraphBaseStyles, paddingLeft: 0 }}>
                        -
                    </p>
                </React.Fragment>
            );
        }
    }

    getTableHeaders = () => {
        let headersList = [];
        let sortingIcon = undefined;

        for (let i = 0; i < tableColumnsList.length; i++) {
            if (tableColumnsList[i].key === this.state.sortingActiveKey) {
                if (this.state.sortingActiveDirection === "asc") {
                    sortingIcon = <span><i className={"nc-icon nc-minimal-down"} style={{ marginLeft: 4 }}></i></span>;
                }
                else {
                    sortingIcon = <span><i className={"nc-icon nc-minimal-up"} style={{ marginLeft: 4 }}></i></span>;
                }
            }
            else {
                sortingIcon = null;
            }

            headersList.push(
                <th style={{ ...tableColumnsList[i].style, fontSize: 10 }} key={"encabezadoDeFuentes." + i} className="noselect">
                    <p style={{ marginBottom: 0, cursor: "pointer" }}
                        onClick={() => { this.sortRecordsBasedOnKey(tableColumnsList[i].key) }}>
                        {tableColumnsList[i].title}
                        {sortingIcon}
                    </p>
                </th>
            );
        }

        return (
            <thead className="muted-text">
                <tr>
                    {headersList}
                </tr>
            </thead>
        );
    }

    getTableRows = () => {
        let rowsList = [];

        for (let i = 0; i < this.state.targetData.length && i < this.props.activeQuantity; i++) {
            rowsList.push(
                <tr key={"key.auditRecord." + i}
                    data-tut={(i === 0) ? "reactour__auditView.auditRecordsTableRowDescription" : ""}>
                    <td style={{ textAlign: "left" }}>
                        <p style={{ marginBottom: 0 }} dangerouslySetInnerHTML={{
                            __html:
                                this.getEmailBolded(this.state.targetData[i].userEmail)
                        }} />
                    </td>

                    <td style={{ textAlign: "right" }}>
                        <p style={{ marginBottom: 0 }}
                            dangerouslySetInnerHTML={{
                                __html:
                                    dateFormatter.getCompoundDate(new Date(this.state.targetData[i].created), { boldHour: true })
                            }} />
                    </td>

                    <td style={{ textAlign: "left" }}>
                        <p style={{ marginBottom: 0 }}
                            dangerouslySetInnerHTML={{
                                __html:
                                    this.state.targetData[i].description
                            }} />
                    </td>
                </tr>
            );
        }
        return rowsList;
    }

    //Métodos operativos:
    sortRecordsBasedOnKey = (key) => {
        let sortedProcessesList = [];
        let originalProcessesList = this.state.targetData;

        if (key !== this.state.sortingActiveKey) {
            sortedProcessesList = originalProcessesList.sort((a, b) => a[key] > b[key] ? 1 : b[key] > a[key] ? -1 : 0);

            this.setState({
                sortingActiveKey: key,
                sortingActiveDirection: "asc",
                targetData: sortedProcessesList
            });
        }
        else {
            if (this.state.sortingActiveDirection !== "asc") {
                sortedProcessesList = originalProcessesList.sort((a, b) => a[key] > b[key] ? 1 : b[key] > a[key] ? -1 : 0);

                this.setState({
                    sortingActiveKey: key,
                    sortingActiveDirection: "asc",
                    targetData: sortedProcessesList
                });
            }
            else {
                sortedProcessesList = originalProcessesList.sort((a, b) => a[key] < b[key] ? 1 : b[key] < a[key] ? -1 : 0);

                this.setState({
                    sortingActiveKey: key,
                    sortingActiveDirection: "des",
                    targetData: sortedProcessesList
                });
            }
        }
    }
}


export default AuditRecordsTable;